import {types} from 'mobx-state-tree';
import EquipmentModel from '../models/equipment-model';

const models = [
    'AT4 2G',
    'AT6 3G',
    'CRX1 NEW',
    'CRX3 NEW',
    'CRX3 MINI',
    'CRX7 3G',
    'E3',
    'E3+',
    'E4 MINI',
    'F1',
    'FMB920',
    'G02',
    'G05',
    'GENÉRICO',
    'GT06',
    'GV50',
    'GV50P',
    'GV55',
    'GV55N',
    'GV75',
    'GV75N',
    'GV300N',
    'GL300N',
    'GV500 OBDII',
    'GT06',
    'iMXT',
    'M1',
    'MXT-100',
    'MXT-100N',
    'MXT-101',
    'MXT-101N',
    'MXT-120',
    'MXT-130D',
    'MXT-140',
    'MXT-141',
    'MXT-142',
    'MXT-150',
    'MXT-151',
    'MXT-160',
    'MXT-162',
    'MXT-G100',
    'NT20',
    'STG T10',
    'STG T100',
    'ST200',
    'ST210',
    'ST215',
    'ST215I',
    'ST215E',
    'ST230',
    'ST240',
    'ST310U',
    'ST340',
    'ST340RB',
    'ST340UR',
    'ST300HD',
    'ST380',
    'ST390',
    'ST500',
    'ST900',
    'ST910',
    'ST940',
    'RST-VT',
    'RST-DTMF',
    'RST-ABS',
    'RST-VT-EVO',
    'RST-VT-PLUS',
    'RST-VTv2',
    'RST-LCv2',
    'RST-MINI',
    'RST-CARGA',
    'RT305',
    'RT325',
    'RT345',
    'TC68S',
    'TK102B',
    'TK103',
    'TK103A',
    'TK103A 3G',
    'TK103B',
    'TK103B 3G',
    'TK105A',
    'TK105B',
    'TK303F 3G',
    'TK303G',
    'TK303G 3G',
    'TK303H',
    'TK303I',
    'TK306',
    'TK311A',
    'TK311B',
    'TK311C',
    'TK403A 4G LTE',
    'TK403B 4G LTE'
];

const EquipmentStore = types
    .model('EquipmentStore', {
        types: types.optional(types.array(EquipmentModel), []),
    })
    .actions((self) => ({
        afterCreate() {
            const types = [];
            models.map((m) => {
                types.push({name: m});
            });
            self.setTypes(types);
        },
        setTypes(data) {
            self.types = data;
        },
    }));

export default EquipmentStore;

